export default __webpack_public_path__ + "static/media/default-img.0d84afb7.png";